/**
 * The onboarding step that allows to create a new brandspace
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { getRoute, ONBOARDING } from 'routes';
import { XC_URL, WORKSPACES_PARAM } from 'config';
import { makeQueryString } from 'utils/url';
import CreateBrandspaceGif from './assets/CreateBrandspaceTop.gif';
import classNames from 'classnames';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	root: {
		width: 500,
		height: '100%',
		margin: '20px auto 0',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	rootWithBrandspace: {
		marginTop: 55
	},
	title: {
		fontWeight: 'bold',
		marginBottom: 7
	},
	text: {
		marginBottom: 40,
		fontWeight: 'bold',
		color: `${theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta, 0.75)}`
	},
	navigation: {
		marginTop: 'auto',
		display: 'flex',
		flexDirection: 'column'
	},
	graphic: {
		width: 390,
		marginBottom: 15
	},
	form: {
		width: 425,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	formSection: {
		'&:first-child + section': {
			width: '100%'
		},
		'&:last-child': {
			marginBottom: 0
		}
	},
	formTitle: {
		textAlign: 'center'
	},
	formInputName: {
		margin: 'auto'
	},
	thumbImg: {
		display: 'block',
		width: 210,
		borderRadius: 15
	},
	thumbBrandName: {
		textAlign: 'center',
		margin: '10px 0 25px'
	}
});

const getDocumentLinkWithRedirectionToOnboarding = (brand) => {
	const { fileId: fileid, providerId: provider, title } = brand.instance;
	return `${XC_URL}?` + makeQueryString({
		fileid,
		provider,
		title,
		[WORKSPACES_PARAM]: `#${getRoute(ONBOARDING).slice(1)}`
	}, true);
};

@withStyles(styles)
class CreateBrandspaceStep extends Component {

	constructor() {
		super();
		this.onBrandspaceAdded = this.onBrandspaceAdded.bind(this);
		this.onStepSkipped = this.onStepSkipped.bind(this);
		this.state = {
			brandspace: undefined
		};
	}

	render() {
		const { classes } = this.props;
		const { brandspace } = this.state;

		return (
			<div className={classNames(classes.root, brandspace && classes.rootWithBrandspace)}>
				{!brandspace && <img
					src={CreateBrandspaceGif}
					alt={localize('onboarding-brandspace-image-alt')}
					className={classes.graphic} />}
				<Typography
					variant='h3'
					align='center'
					className={classes.title}
					paragraph
				>
					{localize('onboarding-brandspace-title')}
				</Typography>
				<Typography
					variant='body2'
					align='center'
					className={classes.text}
				>
					{localize('onboarding-brandspace-text')}
				</Typography>
				{!brandspace &&
					<div className={classes.navigation}>
						<Button
							disableRipple
							data-tid="button-create-brandspace-next"
							onClick={this.onStepSkipped}
							size='small'>{localize('onboarding-brandspace-skip')}</Button>
					</div>
				}
			</div>
		);
	}

	onStepSkipped() {
		this.props.onboarding.skipStep();
	}

	onBrandspaceAdded(data) {
		const { _id: id, displayName, brand } = data.result;
		this.props.onboarding.fulfillStep(true); // true means the onboarding should stay at current step
		this.setState({
			brandspace: { id, displayName, brand }
		});
	}

	renderBrandspaceThumb() {
		const { classes } = this.props;
		const { displayName, brand } = this.state.brandspace;
		return (
			<Fragment>
				<img src={brand.thumbnailURL} title={displayName} className={classes.thumbImg} />
				<Typography variant='body2' className={classes.thumbBrandName}>{displayName}</Typography>
				<Button
					variant='contained'
					color='primary'
					size='large'
					data-tid="button-create-brandspace-open-brand-style"
					component='a'
					onClick={() => {
						window.location = getDocumentLinkWithRedirectionToOnboarding(brand);
					}}
				>
					{localize('onboarding-brandspace-go-to-style-editor')}
				</Button>
			</Fragment>
		);
	}


}

CreateBrandspaceStep.oId = 'create-brandspace';
CreateBrandspaceStep.oTitle = localize('onboarding-brandspace-o-title');
CreateBrandspaceStep.oMessage = localize('onboarding-brandspace-o-message');
CreateBrandspaceStep.oRoute = undefined;

CreateBrandspaceStep.propTypes = {
	classes: PropTypes.object,
	// The onboarding object that contains data from the onboarding wizard, such as methods to fulfill or skip a step
	onboarding: PropTypes.object
};

export default CreateBrandspaceStep;



// WEBPACK FOOTER //
// ./src/containers/OnBoarding/Steps/CreateBrandspaceStep.js